// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ContractNoteDetailsDialogController = function ($scope, $modalInstance, contractNoteId, contract, gettextCatalog, gettext, ContractNotesByContract) {

    $scope.contractNote = (contractNoteId === null) ? new ContractNotesByContract() : ContractNotesByContract.get({
        contractId: contract.Id,
        noteId: contractNoteId
    });

    $scope.cancel = function () {
        $modalInstance.close();
    };

    $scope.save = function () {
        if ($scope.contractNote.NoteId) {
            $scope.contractNote.$update({
                contractId: contract.Id,
                noteId: $scope.contractNote.NoteId
            }, function () {
                $modalInstance.close();
                $scope.notify("success", gettextCatalog.getString(gettext("Contract Note updated successfully.")));

            }, function () {
                $scope.notify("error", gettextCatalog.getString(gettext("Contract Note could not be updated.")));
            });
        } else {
            $scope.contractNote.$save({contractId: contract.Id}, function () {
                $modalInstance.close();
                $scope.notify("success", gettextCatalog.getString(gettext("Contract Note created successfully.")));

            }, function () {
                $scope.notify("error", gettextCatalog.getString(gettext("Contract Note could not be create.")));
            });

        }
    };


};
ContractNoteDetailsDialogController.$inject = ['$scope', '$uibModalInstance', 'contractNoteId', 'contract', 'gettextCatalog', 'gettext', 'ContractNotesByContract'];


